<template>
  <div class="message-input-container" :class="{ 'input-focused': isFocused, 'input-empty': !hasMessages }">
    <div class="input-tools">
      <div class="tooltip">
        <button
          class="tool-button test-button"
          title="测试API连接"
          @click="testConnection"
          :disabled="disabled"
        >
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17 10H3M21 6H3M21 14H3M17 18H3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <span class="tooltip-content">测试API连接</span>
      </div>
      <div class="tooltip">
        <button
          class="tool-button enter-toggle-button"
          :class="{ 'enter-active': useEnterToSend }"
          title="切换回车发送"
          @click="toggleEnterToSend"
          :disabled="disabled"
        >
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 10H21M21 10L15 4M21 10L15 16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <span class="tooltip-content">{{ useEnterToSend ? '已开启回车发送' : '已关闭回车发送' }}</span>
      </div>
      <div class="tooltip">
        <button class="tool-button" title="上传图片">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21 12V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8.5 10C9.32843 10 10 9.32843 10 8.5C10 7.67157 9.32843 7 8.5 7C7.67157 7 7 7.67157 7 8.5C7 9.32843 7.67157 10 8.5 10Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M21 15L16 10L5 21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <span class="tooltip-content">上传图片</span>
      </div>
    </div>

    <div class="input-wrapper">
      <textarea
        class="message-textarea"
        placeholder="请输入您的问题..."
        v-model="inputText"
        @keydown.enter="handleEnterKey"
        @focus="isFocused = true"
        @blur="isFocused = false"
        :disabled="disabled"
        ref="input"
        rows="1"
        @input="autoGrow"
      ></textarea>
      <div class="enter-mode-indicator" v-if="isFocused || inputText">
        {{ useEnterToSend ? 'Enter发送，Shift+Enter换行' : 'Shift+Enter换行，Ctrl+Enter发送' }}
      </div>
    </div>

    <div class="input-actions">
      <div class="tooltip" v-if="inputText.trim()">
        <button
          class="send-button"
          :class="{ 'send-active': inputText.trim() }"
          @click="sendMessage"
          :disabled="disabled || !inputText.trim()"
        >
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22 2L11 13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M22 2L15 22L11 13L2 9L22 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <span class="tooltip-content">发送消息 (Enter发送，Shift+Enter换行)</span>
      </div>
      <div class="tooltip" v-else>
        <button
          class="shortcut-button"
          :disabled="disabled"
        >
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 12H8.01M12 12H12.01M16 12H16.01M21 12C21 16.418 16.97 20 12 20C10.5286 20 9.14629 19.6376 7.94363 19C7.3805 18.7553 6.49306 18.8623 6 19L4 20C3.44772 20 3 19.5523 3 19V16.4334C3 16.1779 3 16.0502 2.99212 15.9286C2.94923 15.2989 3.35045 14.7401 3.95706 14.5452C4.11199 14.4975 4.27532 14.4832 4.6 14.454C4.70117 14.4448 4.75176 14.4402 4.79757 14.4369C4.93103 14.4263 5.03547 14.4396 5.15482 14.4952C5.18001 14.5091 5.20546 14.5242 5.25636 14.5545L5.42298 14.6424C5.5074 14.6853 5.5496 14.7068 5.59114 14.7243C6.38648 15.0543 7.67846 15.5 9 15.5C13.4183 15.5 17 13.0899 17 10C17 6.91015 13.4183 4.5 9 4.5C4.58172 4.5 1 6.91015 1 10C1 11.8514 2.28815 13.4841 4.25 14.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <span class="tooltip-content">快捷指令</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    hasMessages: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      inputText: '',
      isFocused: false,
      useEnterToSend: true // 默认使用回车发送
    }
  },
  methods: {
    handleEnterKey(event) {
      // 如果按下的是Enter键，但没有同时按下Shift键
      if (event.key === 'Enter') {
        if (!event.shiftKey && this.useEnterToSend) {
          // 如果启用了回车发送且没有按下Shift，则发送消息
          event.preventDefault()
          this.sendMessage()
        } else if (event.ctrlKey) {
          // 如果按下了Ctrl+Enter，无论设置如何都发送消息
          event.preventDefault()
          this.sendMessage()
        }
      }
    },
    sendMessage(event) {
      if (event) event.preventDefault()

      if (this.inputText.trim() && !this.disabled) {
        this.$emit('send-message', this.inputText)
        this.inputText = ''
        this.$nextTick(() => {
          this.autoGrow() // 重置高度
        })
      }
    },
    testConnection() {
      this.$emit('send-test')
    },
    autoGrow() {
      const textarea = this.$refs.input
      if (!textarea) return

      // 重置高度，以便我们可以准确计算新高度
      textarea.style.height = 'auto'

      // 计算新高度，但设置最大高度
      const maxHeight = 120 // 像素
      const newHeight = Math.min(textarea.scrollHeight, maxHeight)
      textarea.style.height = newHeight + 'px'

      // 如果内容超过最大高度，显示滚动条
      if (textarea.scrollHeight > maxHeight) {
        textarea.style.overflowY = 'auto'
      } else {
        textarea.style.overflowY = 'hidden'
      }
    },
    toggleEnterToSend() {
      this.useEnterToSend = !this.useEnterToSend
    }
  },
  mounted() {
    // 自动聚焦输入框
    this.$refs.input.focus()
  }
}
</script>

<style scoped>
.message-input-container {
  display: flex;
  align-items: flex-end;
  padding: 10px 16px;
  border-radius: 12px;
  background: white;
  border: 1px solid #e5e7eb;
  transition: all 0.3s ease;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}

.input-empty {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border-color: #d1d5db;
}

.message-input-container.input-focused {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.input-tools {
  display: flex;
  gap: 8px;
  margin-right: 12px;
  padding-bottom: 8px;
}

.tool-button {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  color: #6b7280;
  transition: all 0.2s;
}

.tool-button:hover:not(:disabled) {
  background: #f3f4f6;
  color: #4b5563;
}

.tool-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.tool-button svg {
  width: 20px;
  height: 20px;
}

.test-button {
  color: #3b82f6;
}

.test-button:hover:not(:disabled) {
  background: rgba(59, 130, 246, 0.1);
  color: #2563eb;
}

.input-wrapper {
  flex: 1;
  min-height: 24px;
  position: relative;
  margin-bottom: 10px;
}

.message-textarea {
  width: 100%;
  padding: 8px 0;
  border: none;
  background: transparent;
  font-size: 15px;
  line-height: 1.5;
  color: #1f2937;
  outline: none;
  resize: none;
  max-height: 120px;
  overflow-y: hidden;
}

.message-textarea::placeholder {
  color: #9ca3af;
}

.input-actions {
  display: flex;
  align-items: center;
  margin-left: 12px;
  padding-bottom: 8px;
}

.send-button, .shortcut-button {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e5e7eb;
  border: none;
  cursor: pointer;
  color: #9ca3af;
  transition: all 0.2s;
}

.send-button.send-active {
  background: #3b82f6;
  color: white;
}

.send-button:hover:not(:disabled).send-active {
  background: #2563eb;
}

.send-button:disabled, .shortcut-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.send-button svg, .shortcut-button svg {
  width: 20px;
  height: 20px;
}

.shortcut-button {
  background: transparent;
}

.shortcut-button:hover:not(:disabled) {
  background: #f3f4f6;
  color: #4b5563;
}

.enter-toggle-button {
  background: transparent;
}

.enter-toggle-button:hover:not(:disabled) {
  background: #f3f4f6;
  color: #4b5563;
}

.enter-active {
  background: #3b82f6;
  color: white;
}

/* 自定义tooltip组件样式 */
.tooltip {
  position: relative;
  display: inline-block;
}

.tooltip-content {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background-color: #1f2937;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s, visibility 0.2s;
  z-index: 1000;
  margin-bottom: 5px;
}

.tooltip:hover .tooltip-content {
  opacity: 1;
  visibility: visible;
}

/* 添加箭头 */
.tooltip-content::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #1f2937 transparent transparent transparent;
}

.enter-mode-indicator {
  position: absolute;
  bottom: -20px;
  right: 10px;
  font-size: 12px;
  color: #9ca3af;
  padding: 2px 4px;
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 4px;
  transition: opacity 0.2s;
}
</style>
